import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import {
  fetchTransactions,
  fetchAllTransactions,
  editInActive,
} from "../../features/transaction/transactionSlice";
import Pagination from "../../ui/Pagination";
import Transaction from "./Transaction";
import {
  setPageNo,
  setTransectionType,
  setReset,
} from "../../features/filter/filterSlice";
import ListFilter from "./../../ui/ListFilter";

export default function Transactions({ isListing }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { transactions, isLoading, isError, allTransactions } = useSelector(
    (state) => state.transaction
  );

  const { pageNo, transectionType, search } = useSelector(
    (state) => state.filter
  );

  useEffect(() => {
    dispatch(
      fetchTransactions({ pageNo, limit: 5, type: transectionType, search })
    );
    dispatch(fetchAllTransactions());
  }, [dispatch, pageNo, transectionType, search]);

  // decide what to render
  let content = null;
  if (isLoading) content = <p>Loading...</p>;

  if (!isLoading && isError)
    content = <p className="error">There was an error occured</p>;

  if (!isLoading && !isError && transactions?.length > 0) {
    content = transactions.map((transaction) => (
      <Transaction key={transaction.id} transaction={transaction} />
    ));
  }

  if (!isLoading && !isError && transactions?.length === 0) {
    content = <p>No transactions found!</p>;
  }

  return (
    <>
      <p className="second_heading">Your Transactions:</p>
      {isListing && <ListFilter />}
      <div className="conatiner_of_list_of_transactions">
        <ul>{content}</ul>
        {isListing && !transectionType && !search && (
          <Pagination
            allTransactions={allTransactions}
            transactions={transactions}
          />
        )}
        <div className={`transaction income center`}>
          {isListing ? (
            <>
              <button
                type="button"
                className="link"
                onClick={(e) => {
                  e.stopPropagation();
                  dispatch(setPageNo(1));
                  dispatch(setTransectionType(""));
                  dispatch(setReset());
                  dispatch(editInActive({}));
                  navigate("/");
                }}
                style={{
                  textAlign: "center",
                  fontSize: "16px",
                }}
              >
                Back
              </button>
            </>
          ) : (
            <>
              <Link
                to="/listingTransection"
                className="link"
                onClick={(e) => {
                  e.stopPropagation();
                  dispatch(setReset());
                  dispatch(editInActive({}));
                }}
              >
                View All
              </Link>
            </>
          )}
        </div>
      </div>
    </>
  );
}
